import { LitElement, html, PropertyValues, TemplateResult } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { htmlEncode } from '../../../utils/escape.utils';

export class GzJsonViewerWebComponent extends LitElement {
  @query('.formatted-text-container') preTag: HTMLElement;

  @state() private overlayElement: HTMLElement | null;
  @state() private formattedContent: string;

  @property({ type: Object, attribute: false, reflect: true })
  jsonData = {};

  @property({ type: Number, attribute: true, reflect: true })
  textIndent = 4;

  @property({ type: Boolean, attribute: true, reflect: true })
  lineSeparation = false;

  static get styles() {
    return styles;
  }

  updated(changedProperties: PropertyValues) {
    if (changedProperties.has('jsonData')) {
      if (this.jsonData) {
        this.setFormattedContent();
      }
      this.splitJSONIntoLines();
    }
  }

  render() {
    return html` <div class="container">${this.renderJson()}</div> `;
  }

  private setFormattedContent(): void {
    this.formattedContent = htmlEncode(JSON.stringify(this.jsonData, null, this.textIndent));
  }

  private renderJson(): undefined | TemplateResult {
    return html`<div class="formatted-text-container">
      <div class="content-formatted"></div>
    </div>`;
  }

  private splitJSONIntoLines(): void {
    const codeElement = this.preTag.getElementsByClassName('content-formatted')[0];
    const contentContainer = document.createElement('div');

    if (!codeElement) {
      return;
    }

    const content = this.formattedContent.split('\n');

    for (let i = 0; i < content.length; i++) {
      const lineContainer = document.createElement('div');
      lineContainer.className = 'line-container';

      const lineNumberContainer = document.createElement('span');
      lineNumberContainer.className = 'line-number';
      lineNumberContainer.innerHTML = String(i + 1);

      const lineContent = document.createElement('span');
      lineContent.className = 'line-content';
      lineContent.innerHTML = content[i];

      lineContainer.append(lineNumberContainer);
      lineContainer.append(lineContent);
      codeElement.append(lineContainer);
    }

    codeElement.append(contentContainer);
  }
}
